import React from 'react'
import { useDispatch } from 'react-redux'
import * as gtag from '../lib/gtag'
import { SHOW_POPUP } from '../store/slices/ui'
import ClosingActionBand from './design-system/marketing/ClosingActionBand'
import { useOrderFlow } from './unified-order/OrderFlowProvider'
import QuotePop from './DeferredQuotePopup'

const HomepageClosingActionBand = () => {
  const dispatch = useDispatch()
  const { launchIntent } = useOrderFlow()

  const openQuote = () => {
    gtag.event({
      action: 'home_closing_quote_CTA',
      label: 'leads',
      value: 5,
      category: 'orders'
    })
    launchIntent({
      sourceSurface: 'homepage_closing_action',
      fulfillment: 'delivery_setup'
    }, () => dispatch(SHOW_POPUP({ key: 'quote', size: 'medium', body: <QuotePop /> })))
  }

  const browseEquipment = () => gtag.event({
    action: 'home_closing_catalog_CTA',
    label: 'catalog',
    value: 2,
    category: 'engagement'
  })

  return <ClosingActionBand onQuote={openQuote} onBrowse={browseEquipment} />
}

export default HomepageClosingActionBand
